import { handleActions } from 'redux-actions';
import { AppState } from '../types/store';

import {
  removeCardFromList,
  removeCoreSubscription,
  removeMemberSubscription,
} from '../actions/billing';

export default handleActions<AppState['account'], any>(
  {
    [removeCardFromList.toString()]: (state, action: ReturnType<typeof removeCardFromList>) => {
      return {
        ...state,
        cardsV3: state?.cardsV3?.filter(card => card.storedcardId !== action.payload.cardId),
      };
    },
    [removeCoreSubscription.toString()]: (
      state,
      action: ReturnType<typeof removeCoreSubscription>
    ) => {
      if (!state || !state.coreSubscriptionV3) {
        return state;
      }
      return {
        ...state,
        coreSubscriptionV3: {
          ...state.coreSubscriptionV3,
          isAutorenewalOn: false,
        },
      };
    },
    [removeMemberSubscription.toString()]: (
      state,
      action: ReturnType<typeof removeMemberSubscription>
    ) => {
      if (!state || !state.subscriptionsV3) {
        return state;
      }
      return {
        ...state,
        subscriptions: state.subscriptionsV3.map(subscription =>
          subscription.orderId === action.payload.orderId
            ? { ...subscription, isActive: false }
            : subscription
        ),
      };
    },
  },
  {}
);
